export const selectionGridVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const selectionGridFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform float u_camScale;
uniform vec2 u_size;
uniform bool u_showGrid;

out vec4 outColor;

void main() {
  vec2 viewSize = u_size * u_camScale;
  vec2 pixel = v_texCoord * viewSize;
  
  vec4 color = vec4(0, 0.6, 0.63, 1);
  float borderSize = 1.0; // in pixels
  
  if (
    (pixel.x <= borderSize || pixel.x >= viewSize.x - borderSize)
    ||
    (pixel.y <= borderSize || pixel.y >= viewSize.y - borderSize)
  ) {
    outColor = color;
    return;
  }
  
  if (u_showGrid) {
    vec2 modulo_local = mod(pixel, viewSize /  3.0);

    if (modulo_local.x >= borderSize && modulo_local.y >= borderSize) {
      discard;
    }

    outColor = color;
    return;
  }

  discard;
}`;
